import { generatorSize } from '../../../../constants';

export const createBlobUrl = (el) => {
  const svg = el.outerHTML;
  const preface = '<?xml version="1.0" standalone="no"?>\r\n';
  const blobBoi = new Blob([preface, svg], { type: 'image/svg+xml;charset=utf-8' });
  return URL.createObjectURL(blobBoi);
}

export const downloadAsSvg = (el) => {
  if (!el) return;

  const [svgElement] = el.getElementsByTagName('svg');
  const url = createBlobUrl(svgElement);
  const downloadLink = document.createElement("a");
  downloadLink.href = url;
  downloadLink.download = "cat.svg";
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
}

export const downloadAsJpg = (el) => {
  if (!el) return;

  const canvas = document.createElement('canvas');
  canvas.width = generatorSize;
  canvas.height = generatorSize;
  const [svgElement] = el.getElementsByTagName('svg');
  const url = createBlobUrl(svgElement);
  const image = new Image();
  image.addEventListener('load', () => {
    canvas.getContext('2d').drawImage(image, 0, 0);
    const downloadLink = document.createElement("a");
    downloadLink.href = canvas.toDataURL('image/jpg');
    downloadLink.download = "cat.jpg";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  });
  image.src = url;
}